export var calculatePremiumAmount = function (premium, term) {
    return premium / term;
};
